export const NEW_DATA_RECEIVED = 'NEW_DATA_RECEIVED';
export const ENDPOINT_UPDATED = 'ENDPOINT_UPDATED';
